import {FilterProblemsDto} from '@types';
import {camelcaseKeys} from '@utils/utils';

const toNumber = (value: unknown): number | undefined => {
    if (value === null || value === undefined || value === '') {
        return undefined;
    }
    const num = Number(value);
    return Number.isNaN(num) ? undefined : num;
};

const toBoolean = (value: unknown): boolean | undefined => {
    if (value === null || value === undefined || value === '') {
        return undefined;
    }
    if (value === true || value === false) {
        return value;
    }
    if (value === '1' || value === 'true') {
        return true;
    }
    if (value === '0' || value === 'false') {
        return false;
    }
    return undefined;
};

export const parseFiltersDto = (
    rawFilters: unknown
): FilterProblemsDto | undefined => {
    if (!rawFilters) {
        return undefined;
    }

    // Accept old problem links while keeping the deprecated field out of requests.
    const {resultNumber, ...raw}: Record<string, unknown> =
        camelcaseKeys(rawFilters);

    return {
        ...(raw as FilterProblemsDto),
        limit: toNumber(raw.limit ?? resultNumber),
        offset: toNumber(raw.offset),
        difficultyFrom: toNumber(raw.difficultyFrom),
        difficultyFromElo: toNumber(raw.difficultyFromElo),
        difficultyTo: toNumber(raw.difficultyTo),
        difficultyToElo: toNumber(raw.difficultyToElo),
        ratingFrom: toNumber(raw.ratingFrom),
        ratingTo: toNumber(raw.ratingTo),
        userId: toNumber(raw.userId),
        includeNotRated: toBoolean(raw.includeNotRated),
    };
};

const isOrderDirection = (value: unknown): value is 'asc' | 'desc' =>
    value === 'asc' || value === 'desc';

export const parseOrders = (rawOrders: unknown): [string, 'asc' | 'desc'][] => {
    if (!rawOrders) {
        return [];
    }

    if (Array.isArray(rawOrders)) {
        return rawOrders.reduce<[string, 'asc' | 'desc'][]>((acc, pair) => {
            if (
                Array.isArray(pair) &&
                typeof pair[0] === 'string' &&
                isOrderDirection(pair[1])
            ) {
                acc.push([pair[0], pair[1]]);
            }
            return acc;
        }, []);
    }

    if (typeof rawOrders === 'object') {
        return Object.entries(rawOrders as Record<string, unknown>).reduce<
            [string, 'asc' | 'desc'][]
        >((acc, [key, value]) => {
            if (isOrderDirection(value)) {
                acc.push([key, value]);
            }
            return acc;
        }, []);
    }

    return [];
};
